<template>
    <!-- Show the form if not submitted -->
    <div v-if="!submitted">
     <div class="disclosure-form-page"><!--XHANGE NAME-->
       <!-- Header Section -->
       <div class="header">
         <img src="" alt="Sellers Shield Logo" class="logo" />
       </div>
   
       <!-- Main Content Section -->
       <div class="content">
         <h1>Send Home Sale Disclosure Forms with Confidence.</h1>
         <p>
           Choose the forms you want your seller to fill out. We’ll send them an
           invitation to our Gold Standard Disclosure Process. You’ll receive
           fully signed forms, ready for submission.
         </p>
   
         <!-- Form Options -->
         <div class="form-options">
           <button
             v-for="(form, index) in forms"
             :key="index"
             :class="['form-option', { active: selectedForm === form }]"
             @click="selectForm(form)"
           >
             {{ form }}
           </button>
         </div>
   
         <!-- Submit Button -->
         <button class="send-button" @click="sendForms">Send Forms</button>
       </div>
     </div>
    </div>
 
    <!-- Show the success content if submitted -->
    <div v-else>
       <div class="header">
         <img src="path/to/logo.png" alt="Sellers Shield Logo" class="logo" />
       </div>
 
       <div class="content">
         <h1>Disclosure Forms Sent!</h1>
         <h2>What happens next?</h2>
 
         <div class="steps">
           <div class="step">
             <h3>Sellers receive a guided onboarding email and complete forms with expert tips</h3>
             <p>
               We send a personalized onboarding email explaining disclosure forms, legal protection, and next steps. Our platform highlights errors, explains legal terms, and ensures forms are done right the first time.
             </p>
           </div>
 
           <div class="step">
             <h3>Additional legal protection options</h3>
             <p>
               We offer optional Home Sale Legal Protection™ that covers up to $70,000 in paid legal fees if there is a conflict with the buyer after the sale.
             </p>
             <p>
               Don't worry, sellers can complete forms on our platform at no cost, whether or not they purchase legal protection.
             </p>
           </div>
 
           <div class="step">
             <h3>Completed forms are securely delivered to you</h3>
             <p>
               You’ll receive fully signed documents in your Skyslope Forms Envelope. We’ll notify you once your client completes their forms.
             </p>
           </div>
         </div>
       </div>
     </div>
 
   </template>
   
   <script>
   //import 'skySlopeInvitation.scss';
   export default {
     data() {
       return {
         submitted: false,
         forms: [ //THIS IS GOING TO HAVE TO CHANGE TO BE SOME SORT OF FUNCTION BASED ON SELLER INFO
           "Seller Property Questionnaire",
           "Seller Property Questionnaire",
           "Lead-Based Paint and Lead-Based Paint Hazards Disclosure",
         ],
         selectedForm: null,
       };
     },
     methods: {
       selectForm(form) {
         this.selectedForm = form;
       },
       sendForms() {//NEED TO CHANGE
         if (this.selectedForm) {
           alert(`You have selected: ${this.selectedForm}`);
           this.submitted = true;
         } else {
           alert("Please select a form first.");
         }
       },
     },
   };
   </script>
   
   
   <style scoped>
   /*MOVE TO SCSS AS SOON AS WE HAVE ACTUAL DESIGNS*/
   /* Styles for the header */
   .header {
     text-align: center;
     margin-bottom: 20px;
   }
   
   .logo {
     max-width: 100px;
   }
   
   /* Main content styles */
   .content {
     text-align: center;
     max-width: 500px;
     margin: 0 auto;
   }
   
   h1 {
     font-size: 24px;
     font-weight: bold;
     margin-bottom: 10px;
   }
   
   p {
     font-size: 16px;
     color: #666;
     margin-bottom: 20px;
   }
   
   /* Form option buttons */
   .form-options {
     display: flex;
     flex-direction: column;
     gap: 10px;
   }
   
   .form-option {
     padding: 10px 20px;
     border: 1px solid #ddd;
     background-color: #f9f9f9;
     border-radius: 5px;
     cursor: pointer;
     text-align: left;
   }
   
   .form-option.active {
     border-color: #f5c842;
     background-color: #fff;
     font-weight: bold;
   }
   
   /* Send button */
   .send-button {
     margin-top: 20px;
     padding: 10px 20px;
     background-color: #000;
     color: #fff;
     border: none;
     border-radius: 5px;
     cursor: pointer;
   }
   
   .send-button:hover {
     background-color: #444;
   }
   </style>
   